/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bizbank": {
        "nested": {
          "model": {
            "nested": {
              "BatchRequest": {
                "fields": {
                  "batchSize": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": 20
                    }
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bizbank?.nested?.model?.nested?.BatchRequest) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BatchRequest @ squareup/bizbank/model.proto at 15:1
 */
export const BatchRequest = $root.lookupType('squareup.bizbank.model.BatchRequest');
fixType(BatchRequest);
Builder.createAndAttachToType(BatchRequest);